import toast from './toast'
import svgInline from './svgInline'
import floatingVue from './floatingVue'

export default [toast, svgInline, floatingVue]